<template>
  <div class="qq-login wechat-login">
    <!-- <iframe v-if="qqloginurl != ''" id="qqFrame" name="qqFrame" width="470px" height="700px" :src="qqloginurl" style="background-color:rgb(0, 44, 69, 0.4);transform: translateY(-62px);" frameborder="0" scrolling="no" /> -->
    <!-- <div v-if="!form2.bindMobileTag"  class="login-tips">
      <img src="~assets/img/login/login-tips.png" alt="" srcset=""/>
      <p>请在弹出页操作QQ登录</p>
    </div> -->
    <div class="wechat-login" v-if="form2.bindMobileTag">
      <template v-if="form2.bindMobileTag">
        <div class="card-login login-mobile">
          <div v-show="bindMobileStep == 1">
            <div class="login-title">绑定手机号码</div>
            <div style="width:306px">
              <el-form ref="form2" :model="form2" :rules="rules0">
                <el-form-item prop="mobile">
                  <el-input
                    v-model="form2.mobile"
                    style="max-width:360px"
                    placeholder="请输入手机号码"
                  />
                </el-form-item>
                <el-form-item prop="mobileAuthCode">
                  <el-row type="flex" justify="space-between" :gutter="10">
                    <el-col>
                      <el-input
                        v-model="form2.mobileAuthCode"
                        maxlength="6"
                        placeholder="请输入验证码"
                      />
                    </el-col>
                    <el-col style="flex:1">
                      <el-button
                        type="primary"
                        class="sms-btn"
                        :disabled="smsButtonDisable"
                        @click="getSMS"
                        >{{
                          smsSecond > 0 ? smsSecond + "S" : "获取验证码"
                        }}</el-button
                      >
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item style="margin-bottom:10px">
                  <el-button
                    type="primary"
                    style="width:100%"
                    :disabled="login2ButtonDisabled"
                    @click="bindmobile"
                    >绑定</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
            <img src="~assets/img/qqP1.png" class="step-bar" />
          </div>
          <div v-show="bindMobileStep == 2">
            <div class="login-title">设置密码</div>
            <div style="text-align:center;width:306px;margin:auto">
              <el-form
                ref="formsetpassword"
                :model="formsetpassword"
                onkeydown="if(event.keyCode==13)return false;"
                :rules="rules0"
              >
                <el-form-item prop="password">
                  <el-input
                    v-model="formsetpassword.password"
                    type="password"
                    placeholder="请输入密码"
                  />
                </el-form-item>
                <div style="margin:15px 0px">
                  请使用字母、数字和特殊字符两种及以上组合，且在6-20个字符之间
                </div>

                <el-form-item>
                  <el-button
                    type="primary"
                    style="width:100%"
                    :disabled="!formsetpassword.password.length"
                    @click="bindSetPassword"
                    >设置密码</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
            <img
              src="~assets/img/qqP2.png"
              class="step-bar"
              style="height:25px"
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import rules from "@/utils/rules";
export default {
  data() {
    return {
      qqloginurl: "",
      smsButtonDisable: false,
      login2ButtonDisabled: true,
      setpasswordDialogVisible: false,
      bindMobileStep: 1,
      form2: {
        mobile: "",
        mobileAuthCode: "",
        bindMobileTag: "",
        loginType: 8,
      },
      formsetpassword: {
        acccessAuthCode: "",
        password: "",
        bindMobileTag: "",
        loginType: 8,
        mobile: "",
      },
      rules0: rules,
      smsSecond: 0,
      windowOpen: null,
      regist: false,
      time: null
    };
  },
  mounted() {
    var path = window.location.href
    if (path.indexOf('testlogin') > 0) {
      // 1.testlogin
      const params = {
        openid: 'ohcNX0tqJ-Yitk09gIBafJgI46nc',
      }
      this.$http.login2(params).then(res => {
        this.$store.dispatch('handleLoginSuccess', res.data)
      })
    } else {
      // 2.login

      if (path.indexOf('code') >= 0) {
        // 如果url中包含code,则保存到store中
        if (window.localStorage.getItem('qqurl') !== path) {
          window.localStorage.setItem('qqurl', path)
          window.parent.location = path
          return
        }
        let code = path.split('?')[1]
        code = code.substring(5, code.indexOf('&'))
        const params = {
          code: code,
          loginType: 8,
        }
        this.$http.complex_login(params).then(res => {
          if (res.data.bindMobileTag) {
            // 用户是新用户需要绑定手机用户
            this.form2.bindMobileTag = res.data.bindMobileTag
          } else {
            this.$store.dispatch('handleLoginSuccess', res.data)
          }
        })
      } else {
        this.$http.getQrcodeByqq().then(res => {
          this.qqloginurl = res.data
          window.open(this.qqloginurl,"_self");
        })
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.smsTimer);
    clearInterval(this.time);
    // window.localStorage.removeItem("qqurl");
    
  },
  methods: {
    setValue() {
      clearInterval(this.time);
      this.time = setInterval(() => {
        let url = window.localStorage.getItem("qqurl");

        let code = url.split("?")[1];
        
        code = code.substring(5, code.indexOf("&"));
        const params = {
          code: code,
          loginType: 8,
        };
        this.$http.complex_login(params).then((res) => {
          clearInterval(this.time);
          if (res.data.bindMobileTag) {
            // 用户是新用户需要绑定手机用户
            this.form2.bindMobileTag = res.data.bindMobileTag;
            
          } else {
            this.$store.dispatch("handleLoginSuccess", res.data);
          }
          window.localStorage.removeItem("qqurl");
        });
        if (url.includes("qqlogin") && url.includes("code")) {
          clearInterval(this.time);
        }
      }, 1000);
      
    },
    getSMS() {
      this.$refs.form2.validateField("mobile", (errorMsg) => {
        if (errorMsg === "") {
          // debugger;
          this.$http.bind_mobile_send_sms(this.form2).then((res) => {
            this.login2ButtonDisabled = false;
            this.smsSecond = 60;
            this.smsButtonDisable = true;
            this.smsTimer = setInterval(() => {
              this.smsSecond = this.smsSecond - 1;
              if (this.smsSecond <= 0) {
                this.smsButtonDisable = false;
                clearInterval(this.smsTimer);
              }
            }, 1000);
            this.$toast("短信已发送!");
          });
        }
      });
    },
    bindmobile() {
      this.$refs.form2.validate((valid) => {
        if (valid) {
          this.$http.bind_mobile(this.form2).then((res) => {
            if (res.data.isNewUser === 1) {
              this.bindMobileStep = 2;
              this.formsetpassword.mobile = this.form2.mobile;
              this.formsetpassword.acccessAuthCode = res.data.acccessAuthCode;
              this.formsetpassword.bindMobileTag = this.form2.bindMobileTag;
            } else {
              this.$store.dispatch("handleLoginSuccess", res.data);
            }
          });
        } else {
          return false;
        }
      });
    },
    bindSetPassword() {
      this.$refs.formsetpassword.validate((valid) => {
        if (valid) {
          this.$http
            .bind_mobile_set_password(this.formsetpassword)
            .then((res) => {
              this.$store.dispatch("handleLoginSuccess", res.data);
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.wechat-login {
  @include size(660px,388px);
   margin: 0 auto;
  border-radius:5px;
  .login-tips{
    padding-top:96px ;
    img{
      @include size(100px,100px);
      margin: 0  auto;
    }
    p{
      font-size: 14px;
      padding-top: 18px;
    }
  }
}

</style>


